require('./cardPaymentPurchaseDeferralSuccess.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ constants
const { DATE_FORMAT } = require('constants/index');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const { getFormattedString } = require('utilities/currencyHelper');
const DateHelper = require('utilities/dateHelper');

const CardPaymentPurchaseDeferralSuccess = props => {
    const {
        immCard,
        immCardPaymentPurchaseDeferral,
        immMovement,
        onMainButtonClick,
        processDetail,
        productName,
        quotaStep,
    } = props;

    const cardId = immCard.get('cardId');
    const importObject = {
        amount: Math.abs(immMovement.getIn(['import', 'amount'])),
        currency: immMovement.getIn(['import', 'currency'])
    };

    const formattedImport = getFormattedString(importObject);
    const successMessage = formatText('cardPaymentPurchaseDeferralSuccess-title', [formattedImport, immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'installmentQuantity'])]);

    const immFirstInstallment = immCardPaymentPurchaseDeferral.getIn(['steps', quotaStep, 'installmentsList', 0]);
    const formattedFirstInstallment = getFormattedString(immFirstInstallment.get('installmentTotal'));
    const firstInstallmentDate = DateHelper.formatDate(immFirstInstallment.get('nextAmortizationDate'), DATE_FORMAT);

    const goBackButton = {
        url: `/myprofile/cards/${cardId}/movements`,
        label: formatText('cardPaymentPurchaseDeferralSuccess-goBackButton')
    };

    const successContent = (
        <div>
            <div>
                <FormattedText value="cardPaymentPurchaseDeferralSuccess-successMessageFirst" />
            </div>
            <div className="card-payment-purchase-deferral-success__installment-content">
                <span className="card-payment-purchase-deferral-success__installment-content-amount">{formattedFirstInstallment}</span>
                <span>&nbsp;|&nbsp;{firstInstallmentDate}</span>
            </div>
            <div>
                <FormattedText value="cardPaymentPurchaseDeferralSuccess-successMessageLast" />
            </div>
        </div>
    );

    return (
        <article className="card-payment-purchase-deferral-success">
            <WizardSuccess
                successMessage={successMessage}
                mainButton={goBackButton}
                onMainButtonClick={onMainButtonClick}
                processDetail={processDetail}
                productName={productName}
            >
                {successContent}
            </WizardSuccess>

        </article>
    )
};

CardPaymentPurchaseDeferralSuccess.defaultProps = {
    onMainButtonClick: null,
}

CardPaymentPurchaseDeferralSuccess.propTypes = {
    immCard: PropTypes.object.isRequired,
    immCardPaymentPurchaseDeferral: PropTypes.object.isRequired,
    immMovement: PropTypes.object.isRequired,
    onMainButtonClick: PropTypes.func,
    processDetail: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    quotaStep: PropTypes.number.isRequired,
};

module.exports = CardPaymentPurchaseDeferralSuccess;
